var _defs, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _ellipse82, _ellipse83, _ellipse84, _ellipse85, _ellipse86, _ellipse87, _ellipse88, _ellipse89, _ellipse90, _ellipse91, _ellipse92, _ellipse93, _ellipse94, _ellipse95, _ellipse96, _ellipse97, _ellipse98, _ellipse99, _ellipse100, _ellipse101, _ellipse102, _ellipse103, _ellipse104, _ellipse105, _ellipse106, _ellipse107, _ellipse108, _ellipse109, _ellipse110, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _path8, _ellipse111, _path9, _path0, _path1, _path10, _path11, _rect6, _path12, _path13, _rect7, _ellipse112, _ellipse113, _ellipse114, _ellipse115;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponentEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 169.585,
    height: 87.53,
    viewBox: "0 0 169.585 87.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#172b4d",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172b4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.813,
    y1: 1.097,
    x2: 0.185,
    y2: -0.098,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#e6e9ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c7d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.803,
    y1: -0.073,
    x2: 0.197,
    y2: 1.073,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ffe380"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.023,
    y1: 0.934,
    x2: 0.702,
    y2: 0.316,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a3bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c7e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.147,
    y1: 0.853,
    x2: 0.853,
    y2: 0.146,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.147,
    y1: 0.853,
    x2: 0.853,
    y2: 0.146,
    xlinkHref: "#linear-gradient-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Benefits-modal_recap",
    transform: "translate(-148.264 -102.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck_bluebackground"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck-illustration",
    transform: "translate(134 40)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M14.264,148.1H181.808a.885.885,0,0,1,.885.886h0a.885.885,0,0,1-.885.886H14.264V148.1Z",
    opacity: 0.1,
    fill: "url(#linear-gradient)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(28.642 132.491)",
    fill: "#dfe1e5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(28.689 132.491)",
    fill: "#dfe1e5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(28.733 132.491)",
    fill: "#dfe1e5"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-4",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(28.776 132.491)",
    fill: "#dfe1e5"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(28.82 132.491)",
    fill: "#dfe1e5"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-6",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(28.867 132.491)",
    fill: "#dfe1e5"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-7",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(28.91 132.491)",
    fill: "#dfe1e5"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-8",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(28.954 132.491)",
    fill: "#dfe1e5"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-9",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(28.998 132.491)",
    fill: "#dfe1e5"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-10",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.045 132.491)",
    fill: "#dfe1e5"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-11",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.088 132.491)",
    fill: "#dfe1e5"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-12",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.132 132.491)",
    fill: "#dfe1e5"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-13",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.175 132.491)",
    fill: "#dfe1e5"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-14",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.222 132.491)",
    fill: "#dfe1e5"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-15",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.266 132.491)",
    fill: "#dfe1e5"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-16",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.309 132.491)",
    fill: "#dfe1e5"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-17",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.356 132.491)",
    fill: "#dfe1e5"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-18",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.4 132.491)",
    fill: "#dfe1e5"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-19",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.443 132.491)",
    fill: "#dfe1e5"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-20",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.487 132.491)",
    fill: "#dfe1e5"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-21",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.534 132.491)",
    fill: "#dfe1e5"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-22",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.577 132.491)",
    fill: "#dfe1e5"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-23",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.621 132.491)",
    fill: "#dfe1e5"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-24",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.665 132.491)",
    fill: "#dfe1e5"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-25",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.711 132.491)",
    fill: "#dfe1e5"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-26",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.755 132.491)",
    fill: "#dfe1e5"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-27",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.799 132.491)",
    fill: "#dfe1e5"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-28",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.842 132.491)",
    fill: "#dfe1e5"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-29",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.889 132.491)",
    fill: "#dfe1e5"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-30",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.933 132.491)",
    fill: "#dfe1e5"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-31",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(29.976 132.491)",
    fill: "#dfe1e5"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-32",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.02 132.491)",
    fill: "#dfe1e5"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-33",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.067 132.491)",
    fill: "#dfe1e5"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-34",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.11 132.491)",
    fill: "#dfe1e5"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-35",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.154 132.491)",
    fill: "#dfe1e5"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-36",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.201 132.491)",
    fill: "#dfe1e5"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-37",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.244 132.491)",
    fill: "#dfe1e5"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-38",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.288 132.491)",
    fill: "#dfe1e5"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-39",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.332 132.491)",
    fill: "#dfe1e5"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-40",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.378 132.491)",
    fill: "#dfe1e5"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-41",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.422 132.491)",
    fill: "#dfe1e5"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-42",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.466 132.491)",
    fill: "#dfe1e5"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-43",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.509 132.491)",
    fill: "#dfe1e5"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-44",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.556 132.491)",
    fill: "#dfe1e5"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-45",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.6 132.491)",
    fill: "#dfe1e5"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-46",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.643 132.491)",
    fill: "#dfe1e5"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-47",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.687 132.491)",
    fill: "#dfe1e5"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-48",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.734 132.491)",
    fill: "#dfe1e5"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-49",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.777 132.491)",
    fill: "#dfe1e5"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-50",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.821 132.491)",
    fill: "#dfe1e5"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-51",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.864 132.491)",
    fill: "#dfe1e5"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-52",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.911 132.491)",
    fill: "#dfe1e5"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-53",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.955 132.491)",
    fill: "#dfe1e5"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-54",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(30.998 132.491)",
    fill: "#dfe1e5"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-55",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.045 132.491)",
    fill: "#dfe1e5"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-56",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.089 132.491)",
    fill: "#dfe1e5"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-57",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.133 132.491)",
    fill: "#dfe1e5"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-58",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.176 132.491)",
    fill: "#dfe1e5"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-59",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.223 132.491)",
    fill: "#dfe1e5"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-60",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.267 132.491)",
    fill: "#dfe1e5"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-61",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.31 132.491)",
    fill: "#dfe1e5"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-62",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.354 132.491)",
    fill: "#dfe1e5"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-63",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.401 132.491)",
    fill: "#dfe1e5"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-64",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.444 132.491)",
    fill: "#dfe1e5"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-65",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.488 132.491)",
    fill: "#dfe1e5"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-66",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.531 132.491)",
    fill: "#dfe1e5"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-67",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.578 132.491)",
    fill: "#dfe1e5"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-68",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.622 132.491)",
    fill: "#dfe1e5"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-69",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.665 132.491)",
    fill: "#dfe1e5"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-70",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.709 132.491)",
    fill: "#dfe1e5"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-71",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.756 132.491)",
    fill: "#dfe1e5"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-72",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.799 132.491)",
    fill: "#dfe1e5"
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-73",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.843 132.491)",
    fill: "#dfe1e5"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-74",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.89 132.491)",
    fill: "#dfe1e5"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-75",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.934 132.491)",
    fill: "#dfe1e5"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-76",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(31.977 132.491)",
    fill: "#dfe1e5"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-77",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.021 132.491)",
    fill: "#dfe1e5"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-78",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.068 132.491)",
    fill: "#dfe1e5"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-79",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.111 132.491)",
    fill: "#dfe1e5"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-80",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.155 132.491)",
    fill: "#dfe1e5"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-81",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.198 132.491)",
    fill: "#dfe1e5"
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-82",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.245 132.491)",
    fill: "#dfe1e5"
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-83",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.289 132.491)",
    fill: "#dfe1e5"
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-84",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.332 132.491)",
    fill: "#dfe1e5"
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-85",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.376 132.491)",
    fill: "#dfe1e5"
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-86",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.423 132.491)",
    fill: "#dfe1e5"
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-87",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.466 132.491)",
    fill: "#dfe1e5"
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-88",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.51 132.491)",
    fill: "#dfe1e5"
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-89",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.554 132.491)",
    fill: "#dfe1e5"
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-90",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.601 132.491)",
    fill: "#dfe1e5"
  })), _ellipse89 || (_ellipse89 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-91",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.644 132.491)",
    fill: "#dfe1e5"
  })), _ellipse90 || (_ellipse90 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-92",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.688 132.491)",
    fill: "#dfe1e5"
  })), _ellipse91 || (_ellipse91 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-93",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.735 132.491)",
    fill: "#dfe1e5"
  })), _ellipse92 || (_ellipse92 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-94",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.778 132.491)",
    fill: "#dfe1e5"
  })), _ellipse93 || (_ellipse93 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-95",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.822 132.491)",
    fill: "#dfe1e5"
  })), _ellipse94 || (_ellipse94 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-96",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.865 132.491)",
    fill: "#dfe1e5"
  })), _ellipse95 || (_ellipse95 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-97",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.912 132.491)",
    fill: "#dfe1e5"
  })), _ellipse96 || (_ellipse96 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-98",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.956 132.491)",
    fill: "#dfe1e5"
  })), _ellipse97 || (_ellipse97 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-99",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(32.999 132.491)",
    fill: "#dfe1e5"
  })), _ellipse98 || (_ellipse98 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-100",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(33.043 132.491)",
    fill: "#dfe1e5"
  })), _ellipse99 || (_ellipse99 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-101",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(33.09 132.491)",
    fill: "#dfe1e5"
  })), _ellipse100 || (_ellipse100 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-102",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(33.133 132.491)",
    fill: "#dfe1e5"
  })), _ellipse101 || (_ellipse101 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-103",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(33.177 132.491)",
    fill: "#dfe1e5"
  })), _ellipse102 || (_ellipse102 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-104",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(33.221 132.491)",
    fill: "#dfe1e5"
  })), _ellipse103 || (_ellipse103 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-105",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(33.267 132.491)",
    fill: "#dfe1e5"
  })), _ellipse104 || (_ellipse104 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-106",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(33.311 132.491)",
    fill: "#dfe1e5"
  })), _ellipse105 || (_ellipse105 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-107",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(33.355 132.491)",
    fill: "#dfe1e5"
  })), _ellipse106 || (_ellipse106 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-108",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(33.398 132.491)",
    fill: "#dfe1e5"
  })), _ellipse107 || (_ellipse107 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-109",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(33.445 132.491)",
    fill: "#dfe1e5"
  })), _ellipse108 || (_ellipse108 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-110",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(33.489 132.491)",
    fill: "#dfe1e5"
  })), _ellipse109 || (_ellipse109 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-111",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(33.532 132.491)",
    fill: "#dfe1e5"
  })), _ellipse110 || (_ellipse110 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-112",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(33.532 132.491)",
    fill: "#505f79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M42.23,141.182H154.3v2.44H44.666a2.455,2.455,0,0,1-2.453-2.456h0Z",
    fill: "#505f79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M84.335,132.491h-4.9a8.691,8.691,0,0,0,0,17.383h4.89a8.691,8.691,0,0,0,0-17.383Z",
    fill: "#97a0af"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M124.145,132.491h-4.89a8.691,8.691,0,0,0,0,17.383h4.89a8.691,8.691,0,0,0,0-17.383Z",
    fill: "#97a0af"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M162.111,132.491h-4.89a8.691,8.691,0,0,0,0,17.383h4.89a8.691,8.691,0,0,0,0-17.383Z",
    fill: "#97a0af"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M32.916,141.182a11.322,11.322,0,1,1,22.64,0",
    fill: "#253858"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M72.781,56.079h1.192l0,18.72H72.777Z",
    transform: "translate(-4.833 125.017) rotate(-79.028)",
    fill: "#4c9aff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    d: "M70.624,64.365l20.563,0,0,20.586-20.563,0Z",
    transform: "translate(15.81 -14.123) rotate(11.05)",
    opacity: 0.6,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_",
    width: 69.085,
    height: 75.483,
    transform: "translate(137.393 137.826) rotate(180)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M68.308,62.347v53.208a23.953,23.953,0,0,1,7.286-9.43c11.962-9.356,27.707-4.289,41.485-10.836,8.124-3.862,16.909-12.416,19.875-32.943Z",
    fill: "#ffc400",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "_Rectangle_2",
    width: 41.348,
    height: 75.483,
    transform: "translate(68.308 137.826) rotate(180)",
    fill: "#ff991f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M26.96,117.373a27.14,27.14,0,0,1,4.531-10.1c7.156-9.352,16.58-4.285,24.825-10.836C61.27,92.5,66.632,83.719,68.308,62.347H26.96Z",
    fill: "#ffc400",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 1.78,
    height: 75.483,
    transform: "translate(46.744 62.347)",
    fill: "#ffe380"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    "data-name": "Rectangle",
    width: 13.343,
    height: 12.352,
    transform: "translate(40.436 125.474)",
    fill: "#ffc400"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    "data-name": "Rectangle",
    width: 13.343,
    height: 12.352,
    transform: "translate(97.6 125.474)",
    fill: "#ffe380"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "_Clipping_Path_8",
    d: "M137.393,97.887h15.229c5.859,0,10.611,4.477,10.611,9.993h0a9.983,9.983,0,0,0,6.368,9.158l5.362,2.2a10,10,0,0,1,6.368,9.158v9.426H137.393Z",
    fill: "url(#linear-gradient-4)"
  })), _ellipse111 || (_ellipse111 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-113",
    "data-name": "Oval",
    cx: 3.895,
    cy: 3.899,
    rx: 3.895,
    ry: 3.899,
    transform: "translate(176.057 120.239)",
    fill: "#79e2f2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "_Rectangle_3",
    d: "M139.274,100.071h14.378a8.022,8.022,0,0,1,8.017,8.027v9.762h-22.4V100.071Z",
    fill: "#e6fcff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    "data-name": "Path",
    d: "M152,113.628l-.255-.148a1.507,1.507,0,0,1-.137.195l-1.545.054a8.926,8.926,0,0,1,.543,1.285,25.763,25.763,0,0,0,2.346,1.2c.352.161.7.305,1.036.44a6.133,6.133,0,0,1-.952-2.826A1.62,1.62,0,0,1,152,113.628Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    "data-name": "Path",
    d: "M154.3,112l.757-.057.03.648a.869.869,0,0,1-.432.789h0a.7.7,0,0,1-.214.087l-.231.064c.134,1.943,1.207,3.517,2.46,3.517a1.9,1.9,0,0,0,1.391-.7l-1.743-3.02a.409.409,0,0,1,.707-.406l1.548,2.685a5.422,5.422,0,0,0,.576-2.487c0-2.131-1.136-3.93-2.48-3.93-.979,0-1.843.96-2.242,2.305a.547.547,0,0,1-.087.336Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    "data-name": "Path",
    d: "M143.711,108.84a1.868,1.868,0,0,0,.04.423l.134.023v-.946l-.1.047A1.716,1.716,0,0,0,143.711,108.84Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    "data-name": "Path",
    d: "M73.017,141.182a11.322,11.322,0,1,1,22.64,0",
    fill: "#97a0af"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    "data-name": "Rectangle",
    width: 43.932,
    height: 5.336,
    transform: "translate(137.393 132.491)",
    fill: "#00c7e5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    "data-name": "Path",
    d: "M112.823,141.182a11.322,11.322,0,1,1,22.64,0",
    fill: "#97a0af"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    "data-name": "Path",
    d: "M150.347,141.182a11.322,11.322,0,1,1,22.64,0",
    fill: "#97a0af"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    "data-name": "Rectangle",
    width: 161.649,
    height: 3.352,
    transform: "translate(22.201 137.826)",
    fill: "#97a0af"
  })), _ellipse112 || (_ellipse112 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-114",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(75.655 132.491)",
    fill: "url(#linear-gradient-5)"
  })), _ellipse113 || (_ellipse113 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-115",
    "data-name": "Oval",
    cx: 8.681,
    cy: 8.691,
    rx: 8.681,
    ry: 8.691,
    transform: "translate(115.464 132.491)",
    fill: "url(#linear-gradient-6)"
  })), _ellipse114 || (_ellipse114 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-116",
    "data-name": "Oval",
    cx: 4.96,
    cy: 4.966,
    rx: 4.96,
    ry: 4.966,
    transform: "translate(79.375 136.216)",
    fill: "#00a3bf"
  })), _ellipse115 || (_ellipse115 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-117",
    "data-name": "Oval",
    cx: 4.96,
    cy: 4.966,
    rx: 4.96,
    ry: 4.966,
    transform: "translate(119.184 136.216)",
    fill: "#00a3bf"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentEmpty);
export default __webpack_public_path__ + "static/media/component-empty.dfd932041bdec27010ec09726594574c.svg";
export { ForwardRef as ReactComponent };